var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBC7A2",
    d: "m18.818 35.828-.129.5-.253 1.118-.15.775-.021.123c-.088.502-.166 1.022-.234 1.56l-.088.784-.09 1.022-.042.653-.039.852c-.011.328-.02.663-.023 1.003l-.003.516c0 5.132-3.798 6.513-5.843 4.143-.74-.88-1.25-2.26-1.268-4.143l-.01-.98c-.009-.33-.02-.654-.035-.972l-.027-.499-.081-1.063-.124-1.148c-.04-.312-.082-.617-.129-.917-.108-.698-.236-1.365-.382-2.004l-.1-.427-.12-.47-.136-.502c-.838-2.962 10.123-2.906 9.327.076Zm-4.87-35.828c1.848 0 3.613.334 5.227.94-2.457 1.163-4.157 3.665-4.157 6.563 0 4.01 3.255 7.262 7.271 7.262 2.243 0 4.248-1.014 5.582-2.607.015.255.023.514.023.774 0 8.933-5.104 12.354-8.073 19.855-1.27-.97-3.357-1.41-5.668-1.425-2.332-.015-4.444.406-5.714 1.377-.814-1.956-1.782-3.635-2.766-5.208l-.968-1.518-.485-.754c-2.246-3.509-4.22-6.9-4.22-12.327 0-7.142 6.244-12.932 13.947-12.932Zm8.003 2.34c2.474 1.61 4.359 3.947 5.293 6.677-.648 2.119-2.621 3.66-4.955 3.66-2.861 0-5.18-2.317-5.18-5.174 0-2.673 2.03-4.873 4.634-5.146l.208-.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m18.08 39.53-.114.933-.07.713-.07.926-.03.526-.031.815-.013.564-.006.727c0 2.617-.988 4.259-2.227 4.925-.375-.77-.65-2.207-.67-4.348-.053-4.979.408-8.678 1.138-11.6 1.77.29 3.13.997 2.83 2.117l-.133.522c-.093.373-.18.757-.26 1.15l-.142.744-.11.66-.092.626Zm9.79-27.374c.016.257.024.516.024.776 0 5.038-1.623 8.323-3.572 11.576l-1.488 2.438c-1.066 1.755-2.133 3.62-3.013 5.841-.795-.608-1.914-1.008-3.208-1.226 2.34-6.987 6.218-9.148 6.602-16.854 1.787-.227 3.372-1.102 4.51-2.381l.145-.17Zm-5.92-9.816c2.475 1.61 4.36 3.947 5.294 6.677-.559 1.828-2.104 3.226-4.016 3.575-.178-4.09-1.645-7.047-4.002-9.26.718-.53 1.58-.877 2.517-.975l.208-.017Zm-8.003-2.34c1.849 0 3.614.334 5.228.94-.586.277-1.129.63-1.615 1.047-1.084-.759-2.297-1.413-3.613-1.987Z",
    opacity: 0.304
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.289,
    cy: 7.503,
    fill: "#FFF",
    rx: 5.181,
    ry: 5.174
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.209 11.863c2.86 0 5.179-2.315 5.178-5.173-.001-2.858-2.321-5.175-5.182-5.177 3.554 1.23 5.64 7.638.004 10.35Z",
    opacity: 0.302,
    transform: "rotate(-18 24.796 6.688)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.64 44.734c0 1.422 0 2.844 0 4.266 0 .552.447 1 1 1l5.2 0c.552 0 1-.448 1-1 0-1.359 0-2.718 0-4.076 0-3.543.322-6.628.981-9.096.797-2.982-10.164-3.038-9.326-.077.703 2.485 1.144 5.403 1.144 8.983Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBC7A2",
    d: "M14.134 41.932c1.27 0 2.53.072 3.778.216-.032.593-.054 1.203-.064 1.828l-.005.386-.402-.05c-1.093-.12-2.195-.181-3.307-.181-1.142 0-2.307.064-3.497.191-.007-.765-.035-1.499-.081-2.205l-.527.057c1.394-.162 2.763-.242 4.105-.242Zm0-5.303c1.49 0 2.965.1 4.425.297-.147.69-.27 1.416-.372 2.18l.46.065c-1.486-.23-2.99-.343-4.513-.343-1.274 0-2.579.08-3.913.239-.122-.756-.265-1.477-.428-2.165l-.56.07c1.671-.23 3.305-.343 4.9-.343Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadel);
export default __webpack_public_path__ + "static/media/padel.81742b7d95898a8829e462ab81e17fe0.svg";
export { ForwardRef as ReactComponent };